


  <div class="popup-header">
    <span mat-button (click)="closePopup()" class="material-icons custom-close">
  close
</span>
  <h1 class="popup-title">Comments Section</h1>
</div>

<div mat-dialog-content class="comment-section">
  <div *ngFor="let comment of commentData" class="comment-wrapper">

    <div class="comment-bubble" [ngClass]="{
      'customer-comment': comment.user_type === 'customer',
      'admin-comment': comment.user_type === 'is_admin'
    }">

      <p class="comment-text">{{ comment.comment_text }}</p>

      <span class="comment-timestamp">{{ comment.createdAt | date:'short' }}</span>
    </div>
  </div>

  <div *ngIf="commentData.length === 0" class="no-comments">
    No comments have been posted yet.
  </div>
</div>

<mat-divider></mat-divider>

<div class="comment-input-area">

    <textarea
    class="comment-textarea-field"
      matInput
      cdkTextareaAutosize
      cdkAutosizeMinRows="1"
      cdkAutosizeMaxRows="5"
      placeholder="Type your Comment..."
      [(ngModel)]="newCommentText"
      (keyup.enter)="addComment()"
    ></textarea>


  <!-- <button
  class="comment_send_btn"
    mat-flat-button
    color="primary"
    (click)="addComment()"
    [disabled]="!newCommentText.trim() || isSubmitting"
  >
    <span *ngIf="!isSubmitting">Send</span>
    <mat-spinner *ngIf="isSubmitting" diameter="24" color="#ffff"></mat-spinner>
  </button> -->


  <button
  class="comment_send_btn"
  (click)="addComment()"
  [disabled]="isSubmitting"
  [attr.aria-busy]="isSubmitting ? 'true' : null"
></button>
</div>

